export const extractTimeFromDate = (date: Date) => {
    let hours = date.getHours().toString();
    if (hours.length === 1) hours = 0 + hours;
    let mins = date.getMinutes().toString();
    if (mins.length === 1) mins = 0 + mins;
    return hours + ':' + mins;
};
